module.exports = __webpack_public_path__ + "static/media/ic-clear.f309befa.svg";